<template>
  <v-sheet class="pa-6">
    <v-card>
      <v-toolbar height="120px" flat>
        <v-img src="https://i.imgur.com/l5PGBr1.png" class="mr-3" height="80px" max-width="250px"></v-img>

        <v-spacer></v-spacer>
        <v-toolbar-title>{{cmder_name}}'s Passport <v-chip class="ma-2" @click="copyToClipboard2" small>Copy Link to Passport</v-chip><v-chip color="primary" class="ml-2" label @click.stop="dialog = !dialog" :disabled="menuDisabled">Menu<v-icon right>mdi-menu</v-icon></v-chip></v-toolbar-title>
      </v-toolbar>

      <v-tabs fixed-tabs>
        <v-tab href="#tab1" @click="enableMenu()">
          <v-icon>mdi-passport</v-icon>
        </v-tab>
        <v-tab  href="#tab2" @click="enableMenu()">
          <v-icon>mdi-timeline-check</v-icon>
        </v-tab>
        <v-tab  href="#tab3" @click="disableMenu()">
          <v-icon>mdi-map-marker-check</v-icon>
        </v-tab>
        <v-tab  href="#tabLeaderboardsDSSAs" @click="enableMenu()">
          <v-icon>mdi-format-list-bulleted-square</v-icon>
        </v-tab>
        <v-tab  href="#tabLeaderboardsCommanders" @click="enableMenu()">
          <v-icon>mdi-format-list-checkbox</v-icon>
        </v-tab>
        <v-tab  href="#tabAbout" @click="enableMenu()">
          <v-icon>mdi-information</v-icon>
        </v-tab>

        <v-tab-item id="tab1">
          <v-card flat>
            <v-row>
              <v-col cols="12">
                <v-container fluid>
                  <v-row>
                    <v-col
                      v-for="FC in FCs"
                      :key="FC.number"
                      class="d-flex child-flex"
                      cols="2"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-hover v-slot:default="{ hover }">
                            <v-card
                              flat
                              tile
                              class="d-flex"
                              :elevation="hover ? 12 : 6"
                              v-bind="attrs"
                              v-on:click="copyToClipboard(FC.system, FC.name, getDateVisited(FC.callsign),FC.patch_url,FC.patch_credit,FC.edsmUrl,FC.callsign_formatted,FC.type)"
                              v-on="on"
                            >

                            <v-img v-if="FC.patch_url && FC.type=='FC'" :src="FC.patch_url" aspect-ratio="1" contain>
                                 <v-overlay
                                  :value="overlay"
                                  :absolute="absolute"
                                  :opacity="hasVisited(FC.callsign) ? 0.0 : 0.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-overlay>
                              </v-img>
                              

                              <v-img v-else-if="!FC.patch_url && FC.type=='FC'" src="@/assets/FC_Template2.png" aspect-ratio="1" contain>
                                <div class="FC_Text">
                                  {{FC.name}}
                                </div>
                                <v-overlay
                                  :value="overlay"
                                  :absolute="absolute"
                                  :opacity="hasVisited(FC.callsign) ? 0.0 : 0.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-overlay>
                              </v-img>

                              <v-img v-else-if="FC.patch_url && FC.type=='POI'" :src="FC.patch_url" aspect-ratio="1" contain>
                                <v-overlay
                                  :value="overlay"
                                  :absolute="absolute"
                                  :opacity="hasVisited(FC.callsign) ? 0.0 : 0.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-overlay>
                              </v-img>

                              <v-img v-else-if="!FC.patch_url && FC.type=='POI'" src="@/assets/POI_Template.png" aspect-ratio="1" contain>
                                <div class="POI_Text">
                                  {{FC.name}}
                                </div>
                                <v-overlay
                                  :value="overlay"
                                  :absolute="absolute"
                                  :opacity="hasVisited(FC.callsign) ? 0.0 : 0.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-overlay>
                              </v-img>

                              
                              
                              <v-img v-else-if="FC.patch_url && FC.type=='retired'" :src="FC.patch_url" aspect-ratio="1" contain>
                                <v-overlay
                                  :value="overlay"
                                  :absolute="absolute"
                                  :opacity="hasVisited(FC.callsign) ? 0.0 : 0.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-overlay>
                              </v-img>

                              <v-img v-else-if="!FC.patch_url && FC.type=='retired'" src="@/assets/FC_Template_Retired_Small.png" aspect-ratio="1" contain>
                                <div class="FC_Text">
                                  {{FC.name}}
                                </div>
                                <v-overlay
                                  :value="overlay"
                                  :absolute="absolute"
                                  :opacity="hasVisited(FC.callsign) ? 0.0 : 0.8"
                                >
                                  <template v-slot:placeholder>
                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-row>
                                  </template>
                                </v-overlay>
                              </v-img>


                            </v-card>
                          </v-hover>
                        </template>
                        <span>{{hasVisited(FC.callsign) ? "Visited " + FC.name + " on " + getDateVisited(FC.callsign) : FC.name + " is located in " + FC.system}}</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>



        <v-tab-item id="tab2">
          <v-card flat>
            <div v-for="(item, key) in passport.visited" :key="key">
            <v-timeline v-if="hasVisitedPassport(item)">
              <v-timeline-item color="red lighten-2">
                <template v-slot:icon>
                  <v-avatar height="auto" size="180px">
                    <img v-if="getFcUrl(key)" :src="getFcUrl(key)" />
                    <img v-else src="../assets/FC_Template_Retired.png" />
                  </v-avatar>
                </template>
                <template v-slot:opposite>
                  <span style="padding-right:80px;">{{ getFcName(key) }}</span>
                </template>
                <v-card class="elevation-2">
                  <v-card-title class="headline">{{ getFcName(key) }}</v-card-title>
                  <v-card-text>
                    Commander {{cmder_name}} visited {{ getFcName(key) }}({{key}}) on {{item}}.
                    <br />
                    {{ getFcName(key) }} is located at {{getFcSystem(key)}}.
                    <br />
                    System coordnates are: ({{getFcCoordnates(key)}}).
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item id="tab3">
          <v-card flat>
            <div>
              <l-map
                ref="map"
                :options="map_options"
                :min-zoom="minZoom"
                :max-zoom="maxZoom"
                :zoom="zoom"
                :crs="crs"
                :center="center"
                style="height: 600px; width: 100%;"
              >
                <l-image-overlay :url="mapUrl" :bounds="bounds" />
                <l-marker v-for="FC in FCs" :key="FC.name" :lat-lng="FC" :icon="icon">
                  <l-popup v-if="FC.type== 'FC'"
                    :content="hasVisited(FC.callsign) ? '<b>' + FC.name + '</b>' + '<br>System is located at ' +  FC.system + '<br>Visited on ' + getDateVisited(FC.callsign) : '<b>' + FC.name + '</b>' + '.<br>System is located at ' +  FC.system "
                  />
                   <l-popup v-else
                    :content="hasVisited(FC.callsign) ? '<b>' + FC.name + '</b>' + '<br>System is located at ' +  FC.system + '<br>Visited on ' + getDateVisited(FC.callsign) + '<br><br>More information on the system is located at ' + '<a style=text-decoration:none href=' + '' + FC.edsmUrl + ' target=_blank>EDSM.</a>'   : '<b>' + FC.name + '</b>' + '.<br>System is located at ' +  FC.system + '<br><br>More information on the system is located at ' + '<a style=text-decoration:none href=' + '' + FC.edsmUrl + ' target=_blank>EDSM.</a>'"
                  />
                  <l-icon v-if="FC.type== 'FC'"
                    :icon-url="hasVisited(FC.callsign) ? 'https://img.icons8.com/office/40/000000/marker.png' : 'https://img.icons8.com/ultraviolet/40/000000/marker.png'"
                  ></l-icon>
                  <l-icon v-else
                    :icon-url="hasVisited(FC.callsign) ? 'https://img.icons8.com/office/40/000000/map-pin.png' : 'https://img.icons8.com/ultraviolet/40/000000/map-pin.png'" :icon-size="pinSize"
                  ></l-icon>
                </l-marker>
              </l-map>
            </div>
          </v-card>
        </v-tab-item>

        <v-tab-item id="tabLeaderboardsDSSAs">
          <v-card flat>
            <v-card-title>
              DSSA Leaderboards:
              <v-spacer></v-spacer>
              <v-text-field
                v-model="leaderboards_cmders_search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :items-per-page="5"
              :headers="leaderboards_dssas_headers"
              :items="leaderboards_dssas"
              :search="leaderboards_dssas_search" dense must-sort sort-by="count" sort-desc
            >
                <template v-slot:item.url="{ item }">
                  <v-img class="ma-5"
                    :src="item.url"
                    height="100"
                    width="100"
                  ></v-img>
                 
                </template>

            </v-data-table>
          </v-card>
        </v-tab-item>

        <v-tab-item id="tabLeaderboardsCommanders">
          <v-card flat>
            <v-card-title>
              Commander Leaderboards:
              <v-spacer></v-spacer>
              <v-text-field
                v-model="leaderboards_cmders_search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :items-per-page="10"
              :headers="leaderboards_cmders_headers"
              :items="leaderboards_cmders"
              :search="leaderboards_cmders_search" dense must-sort sort-by="fc" sort-desc
            >
                <template v-slot:item.name="{ item }">
                  <a style="text-decoration: none;" :href="'https://www.edps.dev/?commander=' + item.name">
                    {{ item.name }}
                  </a>
                </template>

            </v-data-table>
          </v-card>
        </v-tab-item>

         <v-tab-item id="tabAbout">
          <v-card flat>
              <v-img class="white--text align-end" height="400px" src="https://imgur.com/64DmHZI.jpg">
          <v-card-title>About DSSA</v-card-title>
        </v-img>
        <v-card-text>
          <div>The Deep Space Support Array (DSSA) is a project to deploy a network of support Carriers throughout the galaxy to help explorers in their deep space travels. Beacons in the profound night, they form a mesh of safe harbors.<br><br> 
          The DSSA is a FleetComm project and was started by CMDR Qohen Leth. For more information, visit the <a style="text-decoration: none;" href="https://forums.frontier.co.uk/threads/the-deep-space-support-array-dssa-a-fleetcomm-initiative.540166/" target="_blank">DSSA Forum thread</a> and get in touch with us in the <a style="text-decoration: none;" href="https://discord.gg/98SPNyt" target="_blank">#dssa-iniative-chat</a> channel on Discord.<br><br>
          The locations of DSSA carriers are listed in the <a style="text-decoration: none;" href="https://bit.ly/dssanetwork" target="_blank">DSSA Tracker</a> and in map form on <a style="text-decoration: none;" href="https://edastro.com/galmap/?layer=regions&pins=DSSAcarriers" target="_blank">EDAstro</a>. </div>
          
          <br>
              <h4>DSSA Passport Credits</h4>

                <ol type="1">
                  <li>Gnauty, Executive Director, DSSA</li>
                  <li><a style="text-decoration: none;" href="https://www.patreon.com/FlyDangerous" target="_blank"> FlyDangerous o7, Lead Developer</a></li>
                  <li>Karaya, Developer</li>
                  <li>Pseodu6626, Developer</li>
                  <li>Salmonllama, Developer</li>
                  <li>Cometborne, Tester</li>
                  <li>Aginggamer, Tester</li>
                  <li>SpaceMeNow, Tester</li>
                  <li>Pisodeuorrior, Tester</li>
                </ol>

        </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
            <v-tabs
                background-color="accent-4"
                centered      
                icons-and-text
              >
                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#tab4">
                  Passports
                  <v-icon>mdi-passport</v-icon>
                </v-tab>

                <v-tab href="#tab5">
                  Recover API Key
                  <v-icon>mdi-account-key-outline</v-icon>
                </v-tab>

                <v-tab href="#tab6">
                  Create New Passport
                  <v-icon>mdi-account-plus</v-icon>
                </v-tab>

                <v-tab-item id="tab4">
                  <v-card flat>

                        <v-autocomplete
                          class="mt-15"
                          v-model="passport_value"
                          :items="passports"
                          label="Passports"
                          solo
                          @change="fetchPassport"
                        ></v-autocomplete>

                  </v-card>
                </v-tab-item>
                <v-tab-item id="tab5">
                  <v-card flat>
                    <v-row>
                      <v-form ref="formGenerateAPIKey" v-model="validGenerateAPIKeyForm" class="mt-15" style="width:100%">
                        <v-autocomplete
                          class=""
                          v-model="generate_passport_value"
                          :items="passports"
                          label="Commander Name"
                          solo
                        ></v-autocomplete>
                        <v-text-field
                          :error-messages="emailErrors"
                          :rules="emailRules"
                          v-model="generate_email"
                          label="Email"
                          required
                          solo
                        ></v-text-field>
                          <v-btn @click="submitGenerateAPIKey" class="mr-4" :disabled="!validGenerateAPIKeyForm">Generate New API Key</v-btn>
                      </v-form >
                    </v-row>
                  </v-card>
                </v-tab-item>
                <v-tab-item id="tab6">
                  <v-card flat>
                    <v-row>
                       <v-form ref="formCreateNewCmder" class="mt-15" style="width:100%" v-model="validCreatePassportForm" lazy-validation>
                        <v-text-field
                          label="Commander's Name"
                          v-model="new_cmder_name"
                          :rules="newCmderNameRules"
                          :error-messages="newCmderErrors"
                          :counter="22"
                          required
                          solo
                        ></v-text-field>
                        <v-text-field
                          :error-messages="emailErrors"
                          label="Email"
                          v-model="new_email"
                          :rules="emailRules"
                          required
                          solo
                        ></v-text-field>
                        <v-text-field
                          :error-messages="emailConfirmErrors"
                          :rules="emailConfirmRules"
                          label="Confirm Email"
                          required
                          solo
                        ></v-text-field>
                          <v-btn @click="submitNewCommander" class="mr-4" :disabled="!validCreatePassportForm">Create New Passport</v-btn>
                      </v-form>
                    </v-row>
                  </v-card>
                </v-tab-item>
              </v-tabs>

              
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-dialog v-model="dialogMessage" persistent max-width="600px">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              {{dialog_text}}
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogMessage = false">Close</v-btn>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPatch" max-width="600px">
      <v-card rounded style="padding:10px;">
          <v-img v-if="patchImage && patchType=='FC'"
              :src="patchImage" class="ma-10"
            ></v-img>

            <v-img v-else-if="!patchImage && patchType=='FC'" src="@/assets/FC_Template2.png" class="ma-10"> <div style="font-size:28px;" class="FC_Text">
                                  {{patchName}}
                                </div></v-img>

            <v-img v-else-if="patchImage && patchType=='POI'" :src="patchImage" class="ma-10"></v-img>

            <v-img v-else-if="!patchImage && patchType=='POI'" src="@/assets/POI_Template.png" class="ma-10"> <div style="font-size:28px;" class="POI_Text">
                                  {{patchName}}
                                </div></v-img>

            <v-img v-else-if="patchImage && patchType=='retired'" :src="patchImage" class="ma-10"></v-img>

            <v-img v-else src="@/assets/FC_Template_Retired_Small.png" class="ma-10"> <div style="font-size:28px;" class="FC_Text">
                                  {{patchName}}
                                </div></v-img>

            <v-card-title>
              {{patchName}}
            </v-card-title>

            <v-card-subtitle>
              <span v-if='patchDate == "" || typeof(patchDate) == "undefined" || typeof(patchDate) === "undefined" || patchDate === undefined || patchDate == null'>
                  {{patchName}} is located in {{patchSystem}} and has not been visited by {{cmder_name}}.
              </span>
              <span v-else>
                  Visited on {{patchDate}}. <br> {{patchName}} is located at {{patchSystem}}.
              </span>
              <span v-if="patchEdsmUrl != ''">
                <br><br>
                More information on the system is located at <a style="text-decoration:none"  :href="patchEdsmUrl" target="_blank">EDSM</a>
              </span>
              <span  v-if='patch_callsign_formatted != ""'>
                <br><br>
                <a style="text-decoration:none" :href="patch_callsign_formatted" target="_blank">Fleetcarrier.space</a>
              </span>
              <br><br>
              <span v-if='patch_credit != ""'>
                Patch Credits: {{patch_credit}}
              </span>
            </v-card-subtitle>
        <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogPatch = false">Close</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    <v-dialog
      v-model="dialogSending"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{sending_text}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialogOpeningMessage">
      <v-card class="mx-auto max-width=400" tile>
        <v-img
          class="white--text align-end"
          height="350px"
          src="https://imgur.com/eawaYS6.jpg"
        >
          <v-card-title>EDPS: Open Beta (0.7v)</v-card-title>
        </v-img>
        <v-card-text>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Welcome to the Elite Dangerous Passport System Open Beta!</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

           <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Special Thanks to all my  <a style="text-decoration: none;" href="https://www.patreon.com/FlyDangerous" target="_blank">Patreons</a> for making EDPS a reality:</v-list-item-title>
               <ol type="1">
                  <li> <a style="text-decoration: none;" href="https://www.edps.dev?commander=spinnelein" target="_blank">Spinnelein</a></li>
                  <li> <a style="text-decoration: none;" href="https://www.edps.dev?commander=LoneJohnSilver" target="_blank">LoneJohnSilver</a></li>
                  <li> <a style="text-decoration: none;" href="https://www.edps.dev?commander=Aginggamer" target="_blank">Aginggamer</a></li>
                </ol>     
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Report issues:</v-list-item-title>
              <v-list-item-subtitle>To report issues please check a list of known issues below and if not listed below then email Email the DSSA Passport Team at <a style="text-decoration: none;" href="mailto: elitedssl@gmail.com">elitedssl@gmail.com</a></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Upcoming features:</v-list-item-title>
              <v-list-item-subtitle>
                <ol type="1">
                  <li><s>Leaderboards</s></li>
                  <li>EDPS backlogger - System will scan the commander's logs and backlog perviously visited Fleet Carriers within the DSSA's network (Only backlogs 25 days - Please use EDMC Plugin for all other use cases)</li>
                  <li>EDiscovery Plugin</li>
                  <li>Dark Mode</li>
                  <li><s>Add Famous Elite Dangerous Site Seeing Locations</s></li>
                  <li>Please visit my <a style="text-decoration: none;" href="https://www.patreon.com/FlyDangerous" target="_blank">Patreon to vote</a> for which features you would like to see next plus provide more direct feedback into the development process!</li>
                </ol>                
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title>Helpful Instructions:</v-list-item-title>
              <v-list-item-subtitle>
                <ol type="1">
                  <li><a style="text-decoration: none;" href="https://github.com/EDCD/EDMarketConnector/wiki/Installation-&-Setup" target="_blank">EDMC</a> and <a style="text-decoration: none;" href="https://github.com/RocketMan1988/EDMC-Passport-System#installation" target="_blank">EDMC-EDPS Plugins</a> are required to submit logs to EDPS.edv. Other methods to import logs may be supported in the future.</li>
                </ol>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogOpeningMessage = false; dialog = true;">Close</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    

     <v-snackbar
      v-model="alert"
      timeout="10000"
    >
      {{alertText}}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="success"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-footer absolute class="font-weight-medium">
      <v-col class="text-center" cols="12">
        Email the DSSA Passport Team at <a style="text-decoration: none;" href="mailto: elitedssl@gmail.com">elitedssl@gmail.com</a>
      </v-col>
    </v-footer>
<br><br>
  </v-sheet>
</template>

<script>
import L from "leaflet";
import { CRS } from "leaflet";
import { LMap, LImageOverlay, LMarker, LPopup, LIcon } from "vue2-leaflet";
import { Icon } from "leaflet";
import axios from 'axios';
import hiddenVars from './Variables/hiddenVars.js'

import FCs_Data from '../assets/FCs.json';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LPopup,
    LIcon,
  },
  data() {
    return {
      tabs: null,
      validForm: false,
      menuDisabled: false,
      dialogPatch: false,
      patchName: "",
      patchSystem: "",
      patchDate: "",
      patchImage: "",
      patchType: "",
      patch_credit: "",
      patchEdsmUrl: "",
      patch_callsign_formatted: "",
      validGenerateAPIKeyForm: false,
      cmderName: "",
      generate_email: "",
      generate_passport_value: "",
      new_cmder_name: "",
      new_email: "",
      new_emailConfirm: "",
      emailErrors: "",
      emailConfirmErrors: "",
      newCmderErrors: "",
      pinSize: [25,25],
      validCreatePassportForm: true,
      cmderNameRules: [
        (v) => !!v || "Commander name is required",
        (v) => v.length <= 22 || "Commander name must be less than 22 characters",
      ],
      newCmderNameRules: [
        (v) => !!v || "Commander name is required",
        (v) => v.length <= 22 || "Commander name must be less than 22 characters",
        (v) => v.length > 0 || "Please enter a commander name",
        //(v) => /^[A-Za-z0-9 ]+$/.test(v) || "No Special Characters are Allowed",
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      emailConfirmRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      drawer: null,
      mapUrl: "https://iili.io/dEuXXs.jpg",
      bounds: [
        [0, 0],
        [4500, 4500],
      ],
      minZoom: -3,
      zoom: -3,
      maxZoom: 2,
      map_options: { zoomControl: false },
      center: [2250, 2250],
      crs: CRS.Simple,
      absolute: true,
      overlay: true,
      icon: L.icon({
        iconUrl: "https://img.icons8.com/ultraviolet/40/000000/marker.png",
        iconSize: [37, 37],
        iconAnchor: [18, 37],
      }),
      alert: false,
      alertText: "",
      dialog: false,
      dialogOpeningMessage: true,
      dialogMessage: false,
      dialog_text: "",
      dialogSending: false,
      sending_text: "",
      passports: ["Aginggamer"],
      passport_value: "Aginggamer",
      passport: {"api_key":"1234","visited":{"TFF34Z":"8/11/2020"},"cmder_name":"Aginggamer","email":"xxx@gmail.com"},
      cmder_name: "Aginggamer",
      FCs: FCs_Data,
      FCs_Sorted: null,
      info: null,
      leaderboards: null,
      leaderboards_cmders: null,
      leaderboards_dssas: null,
      leaderboards_cmders_search: '',
      leaderboards_cmders_headers: [{text: 'Commander:',align: 'start',sortable: false,value: 'name',},{ text: 'Total Dockings:', value: 'fc', sortable: true }],
      leaderboards_dssas_search: '',
      leaderboards_dssas_headers: [{text: '', sortable:false, value:'url'},{text: 'DSSA:',align: 'start',sortable: false,value: 'name',},{ text: 'Total Dockings:', value: 'count', sortable: true }]
    };
  },

  mounted() {
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);

      
    axios
      .get(encodeURI('https://edps-api.d3develop.com/leaderboards/leaderboard?leaderboardDate=Now'), {headers: {
        'x-api-key': hiddenVars.apiKey
      }})
      .then(response => {
        this.leaderboards = response.data;

        this.leaderboards_cmders = response.data.cmders;

        var dssaJsonTable = {"dssas": []};

        for(var i = 0; i < response.data.dssa.length; i++) {
            var obj = response.data.dssa[i];
            if(this.getFcName(Object.keys(obj)[0]) != false) {
              dssaJsonTable.dssas.push({name: this.getFcName(Object.keys(obj)[0]), count : obj[Object.keys(obj)[0]], url: this.getFcUrl(Object.keys(obj)[0])});
              //console.log(obj[Object.keys(obj)[0]]);
            
            }
            //console.log(this.getFcName(Object.keys(obj)[0]));
            //console.log(obj[Object.keys(obj)[0]]);
        }

        console.log(dssaJsonTable.dssas);

        this.leaderboards_dssas = dssaJsonTable.dssas;
        console.log(response.data);
      });

    if(params.get("commander")) {

      //Commander Name was provided!
      this.dialogOpeningMessage = false;
      this.cmder_name = params.get("commander");
      this.cmderName = this.cmder_name;

      //Get Passport
      axios
        .get(encodeURI('https://edps-api.d3develop.com/passports/passport?cmder_name=' + this.cmderName), {headers: {
          'x-api-key': hiddenVars.apiKey
        }})
        .then(response => {
          if('No User Found' == response.data) {
            axios.get('https://edps-api.d3develop.com/passports/passport?cmder_name=Aginggamer', {headers: {
              'x-api-key': hiddenVars.apiKey
            }})
            .then(response2 => {
              this.dialog_text = "Commander " + this.cmderName + " was not found! Please make sure they are signed up.";
              this.dialogMessage = true;
              this.cmder_name = 'Aginggamer'
              this.cmderName = 'Aginggamer'
              this.passports = response2.data
            });

          }
          else {
            this.passport = response.data;
          }
        });


      axios
        .get('https://edps-api.d3develop.com/passports', {headers: { 
              'x-api-key': hiddenVars.apiKey
        }})
        .then(response => (this.passports = response.data ));  
      

    }
    else {

      this.cmderName = this.cmder_name;
      //Get Passport
      axios
        .get('https://edps-api.d3develop.com/passports/passport?cmder_name=Aginggamer', {headers: {
          'x-api-key': hiddenVars.apiKey
        }})
        .then(response => (this.passport = response.data));


      axios
        .get('https://edps-api.d3develop.com/passports', {headers: { 
              'x-api-key': hiddenVars.apiKey
        }})
        .then(response => (this.passports = response.data ));
    }
  },
  created() {

   

  },
  watch: {
    FCs: function (val) {
      this.FCs_Sorted = val.sort(function(a, b) {
      var keyA = Number(a.number),
      keyB = Number(b.number);
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    })
    }
  },
  methods: {
    checkIfFC: function(pointType) {
      if(pointType == 'FC') {
        return true;
      }
      else {
        return false;
      }
    },
    fetchPassport: function () {
      this.sending_text = "Fetching commander " + this.passport_value + "'s passport";
      this.dialogSending = true;
      axios
      .get(encodeURI('https://edps-api.d3develop.com/passports/passport?cmder_name=' + this.passport_value), {headers: {
        'x-api-key': hiddenVars.apiKey
      }})
      .then((response) => {
        this.passport = response.data;
        this.cmder_name = this.passport.cmder_name_formatted;
        this.dialogSending = false;
      });
    },
    submitGenerateAPIKey: function (e) {
      e.preventDefault();

      if(this.$refs.formGenerateAPIKey.validate())
      {
        this.sending_text = "Generating New API Key: Please Standby";
        this.dialogSending = true;
        axios.post('https://edps-api.d3develop.com/passports/passport/api', {
                      cmder_name: this.generate_passport_value,
                      email: this.generate_email
                  },{headers: {
                    'x-api-key': hiddenVars.apiKey
                  }})
                  .then( (response) => {
                    this.dialog = false;
                    this.dialogSending = false;
                    if(response.data == "Your email doesn't match the one on record") {
                      this.dialog_text = "Your email doesn't match the one on record! Please use the exact email you used to sign up.";
                      this.dialogMessage = true;
                    }
                    else {
                      this.dialog_text = "Generated new API Key and Email Sent with your API Key! Please check your Spam folder in case it ends up there.";
                      this.dialogMessage = true;
                    }
                  })
                  .catch((error) => {
                      this.dialog = false;
                      this.dialogSending = false;
                      this.dialog_text = "There was an issue with generating a new API Key. Please try again and if the issue continues then please contact the DSSA Coding Monkeys at: elitedssl@gmail.com";
                      this.dialogMessage = true;
                      console.log(error);
                  });
      }
    },
    submitNewCommander: function (e) {
      e.preventDefault();

      if(this.$refs.formCreateNewCmder.validate())
      {
        this.sending_text = "Creating Commander: Please Standby";
        this.dialogSending = true;
        axios.post('https://edps-api.d3develop.com/passports/passport', {
                      cmder_name: this.new_cmder_name,
                      email: this.new_email
                  },{headers: {
                    'x-api-key': hiddenVars.apiKey
                  }})
                  .then( (response) => {
                    this.dialog = false;
                    this.dialogSending = false;
                    if(response.data == "Passport exists") {
                      this.dialog_text = "Your commander already exists within the database!";
                      this.dialogMessage = true;
                    }
                    else {
                      this.dialog_text = "Your commander has been added to the database. An email with additional details was sent to the provided email address. If you provided a fake email address then please immediately contact us at: elitedssl@gmail.com.";
                      this.dialogMessage = true;
                      axios
                        .get('https://edps-api.d3develop.com/passports', {headers: {
                          'x-api-key': hiddenVars.apiKey
                        }})
                        .then(response => (this.passports = response.data ));
                    }
                  })
                  .catch((error) => {
                      this.dialog = false;
                      this.dialogSending = false;
                      this.dialog_text = "There was an issue with the creation of your commander: " + error + ". Please try again and if the issue continues then please contact the DSSA Coding Monkeys at: elitedssl@gmail.com";
                      this.dialogMessage = true;
                  });
      }
     
    },
    hasVisitedPassport: function (visited) {
      if (visited == "false" || typeof visited == 'undefined' || visited == false || visited == null || visited === null || visited == this.cmder_name || visited == "dssaPassports"){
        return false;
      }
      else{
        return true;
      }
    },
    hasVisited: function (station) {

      if(this.passport.visited[station] == undefined) {
        return false;
      }
      else
      {
        if(this.passport.visited[station] == "false" || this.passport.visited[station] == false || this.passport.visited[station] == null){
          return false;
        }
        else{
          return true;
        }

      }

    },
    getDateVisited: function (station) {
      return this.passport.visited[station];
    },
    getFcName: function (visit) {
      for (var i = 0; i < this.FCs.length; i++) {
        if (this.FCs[i].callsign == visit) {
          return this.FCs[i].name;
        } 
      }
      return "Retired Fleet Carrier";
    },
    getFcSystem: function (visit) {
      for (var i = 0; i < this.FCs.length; i++) {
        if (this.FCs[i].callsign == visit) {
          return this.FCs[i].system;
        } 
      }

      return false;
    },
    getFcCoordnates: function (visit) {
      for (var i = 0; i < this.FCs.length; i++) {
        if (this.FCs[i].callsign == visit) {
          return (
            this.FCs[i].location_x +
            ", " +
            this.FCs[i].location_y
          );
        } 
      }

      return false;
    },
    getFcUrl: function (visit) {
      for (var i = 0; i < this.FCs.length; i++) {
        if (this.FCs[i].callsign == visit) {
          return this.FCs[i].patch_url;
        } 
      }

      return false;
    },
    copyToClipboard: function (system, name, date, url, patchCredits, edsmUrl, callsign, pointType) {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = system;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      this.alertText = "Copied " + system + " to the clipboard!";
      this.alert = true;
      
      this.patchName = name;
      this.patchSystem = system;
      this.patchDate = date;
      this.patchImage = url;
      this.patch_credit = patchCredits;
      this.patchEdsmUrl = edsmUrl;
      this.patchType = pointType;
      if(pointType == 'FC') {
        this.patch_callsign_formatted = 'https://fleetcarrier.space/carrier/' + callsign;
      }
      else {
        this.patch_callsign_formatted = '';
      }

      this.dialogPatch = true;

    },
    copyToClipboard2: function () {
      var dummy = document.createElement("textarea");
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = 'https://www.edps.dev?commander=' + this.cmder_name;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);

      this.alertText = "Copied link to " + this.cmder_name + "'s passport to the clipboard!";
      this.alert = true;

    },
    disableMenu: function () {
      this.menuDisabled = true;
    },
    enableMenu: function () {
      this.menuDisabled = false;
    }
  },

  computed: {




  }

};
</script>

<style>

.FC_Text {
    width: 80%;
    /* height: 100%; */
    text-align: center;
    /* text-anchor: middle; */
    font-size: 18px;
    font-family: impact;
    /* display: block; */
    margin: auto;
    COLOR: #76a6c4;
    /* X: 50%; */
    /* Y: 50%; */
    TOP: 50%;
    POSITION: relative;
}

.POI_Text {
    width: 80%;
    /* height: 100%; */
    text-align: center;
    /* text-anchor: middle; */
    font-size: 18px;
    font-family: impact;
    /* display: block; */
    margin: auto;
    COLOR: #ffc917;
    /* X: 50%; */
    /* Y: 50%; */
    TOP: 40%;
    POSITION: relative;
}

.v-timeline-item__body {
  padding-left: 80px;
  padding-right: 20px;
}

#shadowBox {
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.2);
    /* Black w/opacity/see-through */
    border: 3px solid;
}

.rainbow {
    text-align: center;
    text-decoration: underline;
    font-size: .875rem;
    font-family: monospace;
    letter-spacing: 2px;
}
.rainbow_text_animated {
    background: linear-gradient(to right, #6666ff, #0099ff , #00ff00, #ff3399, #6666ff);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    animation: rainbow_animation 4s ease-in-out infinite;
    background-size: 400% 100%;
}

@keyframes rainbow_animation {
    0%,100% {
        background-position: 0 0;
    }

    50% {
        background-position: 100% 0;
    }
}
</style>